import React from 'react';
import PropTypes from 'prop-types';

const StepTitle = ({ title, subtitle }) => (
    <hgroup className="text-center leading-snug mb-8">
        <h1 className="text-gray-80 font-black text-21 md:text-28">{title}</h1>
        {subtitle && <p className="text-gray-50 text-16 md:text-18 mt-4">{subtitle}</p>}
    </hgroup>
);

StepTitle.propTypes = {
    title: PropTypes.node.isRequired,
    subtitle: PropTypes.node,
};

StepTitle.defaultProps = {
    subtitle: null,
};

export default StepTitle;
